import React from "react";
import UserProfile from "../Users/UserProfile";
import { PageHeader } from "../../CommonElements/PageTitle";
import ChangeProfileBtn from "../../Component/BtnAsLink";
import { useTranslation } from "react-i18next";
import {
  Edit02Icon,
  LockKeyIcon,
  Mail01Icon,
} from "@hugeicons/core-free-icons";
import { Link } from "react-router-dom";
import { Space } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import BtnAsLink from "../../Component/BtnAsLink";
import { useGetCurrentUserProfileQuery } from "../../services/profile/profile";

export const CurrentUserProfile = () => {
  const {
    data: userRes,
    isLoading,
    isFetching,
    isError,
  } = useGetCurrentUserProfileQuery();
  const user = userRes?.data?.data;
  const loading = isLoading || isFetching;
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t("PERSONAL_PROFILE")}
        backTo={`/app/user_management/users`}
      >
        <Space>
          <BtnAsLink
            className="btn-secondary btn-outline"
            link="change-email"
            icon={<HugeiconsIcon size={20} icon={Mail01Icon} />}
          >
            {t("CHANGE_EMAIL")}
          </BtnAsLink>
          <BtnAsLink
            className="btn-secondary btn-outline"
            link={`change-password`}
            icon={<HugeiconsIcon size={20} icon={LockKeyIcon} />}
          >
            {t("CHANGE_PASSWORD")}
          </BtnAsLink>
          <BtnAsLink
            className="btn-primary"
            link={`edit`}
            icon={<HugeiconsIcon size={20} icon={Edit02Icon} />}
          >
            {t("CHANGE_PROFILE_DATA")}
          </BtnAsLink>
        </Space>
      </PageHeader>
      <UserProfile
        {...{
          loading,
          isError,
          user,
          id: user?.id,
        }}
      />
    </>
  );
};
